// Lib
import React from 'react';

// Components
import Button from '../../../../../../components/buttons/Button';

// Styles
import './CustomColorPickerContainer.scss';

import { useTranslator } from '../../../../../../components/i18n/useTranslator';

type CustomColorPickerContainerProps = {
    closePopup?: () => void;
    openCustomColorPicker: () => void;
};

const CustomColorPickerContainer = ({ closePopup, openCustomColorPicker }: CustomColorPickerContainerProps) => {
    const translate = useTranslator('popup', 'color.customPicker');

    const onCustomColorButtonClick = () => {
        openCustomColorPicker();
        closePopup?.();
    };

    return (
        <div className="CustomColorPickerContainer">
            <div className="custom-color-picker-button-container">
                <Button className="custom-color-picker" onClick={onCustomColorButtonClick}>
                    <div className="color-wheel" />
                    <div className="color-picker-text">
                        {translate('customColorLabel')}
                        …
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default CustomColorPickerContainer;
